import { PartOfDay } from '../types/time-off-part-of-day';

/**
 * Maps a response-side `PartOfDay` enum to the backend's 1-based `dayPartNumber`
 * (what create/update payloads expect). FULL_DAY / CUSTOM / hourly have no part
 * number → undefined.
 */
export const partOfDayToDayPartNumber = (partOfDay: PartOfDay): number | undefined => {
  switch (partOfDay) {
    case PartOfDay.FirstHalf:
    case PartOfDay.FirstQuarter:
      return 1;
    case PartOfDay.SecondHalf:
    case PartOfDay.SecondQuarter:
      return 2;
    case PartOfDay.ThirdQuarter:
      return 3;
    case PartOfDay.FourthQuarter:
      return 4;
    default:
      return undefined;
  }
};
